import { Component, OnInit } from '@angular/core';
import { SnackbarService,
} from '@tangilla/tg-ng-core';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from '../core/services/survey/survey.service';
import { SurveyNavigationErrorsService } from '../core/services/survey/survey-navigation-errors.service';
import { TangillaFormsService } from './services/tangilla-forms.service';
import { switchMap } from 'rxjs';
import { TangillaFormsConfigService } from './services/tangilla-forms-config.service';

@Component({
  selector: 'tgf-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {
  isLoading = false;
  isLoadingBillingEntity = false;
  isLoadingQueryParams = false;
  isLoadingReportCategories = false;

  previewSwitchUrl?: string;
  liveLinkUrl?: string;

  formId?: string;

  constructor(
    private route: ActivatedRoute,
    public surveyService: SurveyService,
    private surveyNavigationErrorsService: SurveyNavigationErrorsService,
    private snackbarService: SnackbarService,
    public tangillaFormsService: TangillaFormsService,
    public tangillaFormsConfigService: TangillaFormsConfigService) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.loadRouteParams();
    this.isLoading = false;
  }

  private loadRouteParams() {
    this.isLoadingQueryParams = true;
    this.route.params
      .pipe(switchMap((data: any) => {
        this.formId = data?.id;
        return this.route.queryParams;
      }))
      .subscribe(data => {
        this.processQueryParams(data);
        this.isLoadingQueryParams = false;
      });
  }

  private processQueryParams(queryParams: any) {
    this.processExtraQueryParams(queryParams);
    const params = Object.keys(queryParams)
      .reduce((obj, key) => {
        (obj as any)[key] = queryParams[key];
        return obj;
      }, {});

    if (this.surveyService.isPreview && this.surveyService.previewVersion !== '1') {
      this.surveyNavigationErrorsService.ignoreValidations = true;
    }
    if (this.formId) {
      this.tangillaFormsService.processFormId(this.formId, params);
    } else {
      this.snackbarService.error('This form was not found');
    }
  }

  private processExtraQueryParams(queryParams: any) {
    const previewVersionQueryParamText = this.processPreviewSpecificProperties(queryParams);
    const personIdQueryParamText = this.processPersonIdTokenParameters(queryParams);

    this.setLinksUrls(previewVersionQueryParamText, personIdQueryParamText);
  }

  private setLinksUrls(previewVersionQueryParamText: string, personIdQueryParamText: string) {
    const url = `${window.location.origin}${window.location.pathname}`;

    this.previewSwitchUrl = `${url}?preview=true${previewVersionQueryParamText}${personIdQueryParamText}`;
    this.liveLinkUrl = `${url}?${personIdQueryParamText}`;
  }

  private processPreviewSpecificProperties(queryParams: any) {
    const preview = queryParams.preview;
    const previewVersion = queryParams.v;

    this.surveyService.isPreview = preview === 'true';
    this.surveyService.previewVersion = previewVersion;

    let previewVersionQueryParamText = '';
    if (previewVersion !== '1') {
      previewVersionQueryParamText = '&v=1';
    }

    return previewVersionQueryParamText;
  }

  private processPersonIdTokenParameters(queryParams: any) {
    const personId = queryParams.person_id;
    const token = queryParams.token;
    return personId || token ? `&person_id=${personId || token}` : '';
  }

  isItLoading() {
    return this.isLoading ||
      this.isLoadingBillingEntity ||
      this.isLoadingReportCategories ||
      this.isLoadingQueryParams ||
      this.tangillaFormsService.isItLoading() ||
      this.tangillaFormsConfigService.isItLoading();
  }
}
